import { PASSWORD_VALIDATION } from './registrationConstants.ts';

export const validateEmail = (email: string): { isValid: boolean; error?: string } => {
  if (!email) {
    return { isValid: false, error: 'El email es obligatorio' };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, error: 'Ingresa un email válido' };
  }

  return { isValid: true };
};

export const validatePassword = (password: string): { isValid: boolean; error?: string } => {
  if (!password) {
    return { isValid: false, error: 'La contraseña es obligatoria' };
  }

  if (password.length < PASSWORD_VALIDATION.MIN_LENGTH) {
    return { isValid: false, error: 'La contraseña debe tener al menos 8 caracteres entre letras y números' };
  }

  if (PASSWORD_VALIDATION.REQUIRE_LETTER) {
    const hasLetter = /[a-zA-Z]/.test(password);
    const hasNumber = /\d/.test(password);

    if (!hasLetter || !hasNumber) {
      return { isValid: false, error: 'La contraseña debe contener letras y números' };
    }
  }

  return { isValid: true };
};

export const validateConfirmPassword = (password: string, confirmPassword: string): { isValid: boolean; error?: string } => {
  if (!confirmPassword) {
    return { isValid: false, error: 'Confirma tu contraseña' };
  }

  if (confirmPassword !== password) {
    return { isValid: false, error: 'Las contraseñas no coinciden' };
  }

  return { isValid: true };
};

export const validateCode = (code: string): boolean => {
  return /^\d{6}$/.test(code);
};

export const parsePreRegisterError = (error: any): { message: string; shouldRedirectToLogin?: boolean; isPreRegistered?: boolean; isAlreadyValidated?: boolean } => {
  const originalMessage = error?.response?.data?.message || '';
  const responseData = error?.response?.data;

  if (originalMessage === 'El usuario ya está registrado' && responseData?.validated !== false) {
    return {
      message: 'Ya contamos con ese email registrado. Por favor, ve al login para acceder a tu cuenta.',
      shouldRedirectToLogin: true,
    };
  }

  if (originalMessage === 'El usuario ya está registrado' && responseData?.validated === false) {
    return {
      message: originalMessage,
      isPreRegistered: true,
    };
  }

  if (originalMessage.includes('pre-registrado') || originalMessage.includes('already pre-registered')) {
    if (responseData?.validated === true) {
      return {
        message: originalMessage,
        isPreRegistered: true,
        isAlreadyValidated: true,
      };
    } else {
      return {
        message: originalMessage,
        isPreRegistered: true,
      };
    }
  }

  return {
    message: originalMessage || 'Ocurrió un error. Intenta nuevamente.',
  };
};
